import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {
  TextField, Button, Box, Typography, List, ListItem, ListItemText, ListItemButton, Divider, Badge, Avatar
} from '@mui/material';
import dmIcon from "../components/Icons/dmIcon.png";
import notificationIcon from "../components/Icons/notificationIcon.png";
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

function NotificationsPage() {
    const history = useHistory();
    const location = useLocation();
    const { userId, username } = location.state || {};

    // state for search input
    const [searchQuery, setSearchQuery] = useState("");

    // state for search results
    const [results, setResults] = useState([]);

    const [typingTimeout, setTypingTimeout] = useState(null);
    

    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");

    const [conversations, setConversations] = useState([]); // all users you messaged
    const [selectedUser, setSelectedUser] = useState(null); // currently active chat user

    const [unreadCount, setUnreadCount] = useState(0);

    const [unreadByUser, setUnreadByUser] = useState({});

    const [newFollowersCount, setNewFollowersCount] = useState(0);
    const [notificationsCount, setNotificationsCount] = useState(0);

    const [followNotifications, setFollowNotifications] = useState([]);

    const [activeSection, setActiveSection] = useState(null);

    const [upvoteNotifications, setUpvoteNotifications] = useState([]);
    const [newUpvoteCount, setNewUpvoteCount] = useState(0);

    const [commentNotifications, setCommentNotifications] = useState([]);
    const [newCommentsCount, setNewCommentsCount] = useState(0);

    const [hoveredButton, setHoveredButton] = useState(null);
    const [followingMap, setFollowingMap] = useState({});
/*
    const fetchFollowNotifications = async () => {
        try {
            const res = await axios.get("/user/follow-notifications");
            setFollowNotifications(res.data.followNotifications);
        } catch (err) {
            console.error("Error fetching follow notifications:", err);
        }
    };

    useEffect(() => {
        const fetchNotificationsAndFollowing = async () => {
        try {
            const notifRes = await axios.get("/user/follow-notifications");
            const notifs = notifRes.data.followNotifications || [];
            // Fetch current user's following list
            const followRes = await axios.get("/user/following");
            const followingIds = followRes.data.following.map((f) => f._id);

            // Build a quick lookup map
            const map = {};
            notifs.forEach((n) => {
                map[n._id] = followingIds.includes(n._id);
            });
            setFollowingMap(map);
        } catch (err) {
            console.error("Error fetching follow notifications or following list:", err);
        }
        };

        fetchNotificationsAndFollowing();
    }, []);
    */
   // ── Pagination state per section ───────────────────────
    const [followSkip, setFollowSkip] = useState(0);
    const [followHasMore, setFollowHasMore] = useState(false);
    const [followLoadingMore, setFollowLoadingMore] = useState(false);

    const [upvoteSkip, setUpvoteSkip] = useState(0);
    const [upvoteHasMore, setUpvoteHasMore] = useState(false);
    const [upvoteLoadingMore, setUpvoteLoadingMore] = useState(false);

    const [commentSkip, setCommentSkip] = useState(0);
    const [commentHasMore, setCommentHasMore] = useState(false);
    const [commentLoadingMore, setCommentLoadingMore] = useState(false);

    const LIMIT = 10;

    // ── Fetch functions ─────────────────────────────────────
    const fetchFollowNotifications = async (skip = 0, append = false) => {
    try {
        const res = await axios.get("/user/follow-notifications", {
        params: { skip, limit: LIMIT }
        });
        const { followNotifications, hasMore } = res.data;
        setFollowNotifications(prev =>
        append ? [...prev, ...followNotifications] : followNotifications
        );
        setFollowSkip(skip + followNotifications.length);
        setFollowHasMore(hasMore);

        // Build followingMap for any new notifications
        const followRes = await axios.get("/user/following");
        const followingIds = followRes.data.following.map(f => f._id);
        const map = {};
        followNotifications.forEach(n => {
        map[n._id] = followingIds.includes(n._id);
        });
        setFollowingMap(prev => append ? { ...prev, ...map } : map);
    } catch (err) {
        console.error("Error fetching follow notifications:", err);
    }
    };

    const fetchUpvoteNotifications = async (skip = 0, append = false) => {
    try {
        const res = await axios.get("/user/upvote-notifications", {
        params: { skip, limit: LIMIT }
        });
        const { upvoteNotifications, hasMore } = res.data;
        setUpvoteNotifications(prev =>
        append ? [...prev, ...upvoteNotifications] : upvoteNotifications
        );
        setUpvoteSkip(skip + upvoteNotifications.length);
        setUpvoteHasMore(hasMore);
    } catch (err) {
        console.error("Error fetching upvote notifications:", err);
    }
    };

    const fetchCommentNotifications = async (skip = 0, append = false) => {
    try {
        const res = await axios.get("/user/comment-notifications", {
        params: { skip, limit: LIMIT }
        });
        const { commentNotifications, hasMore } = res.data;
        setCommentNotifications(prev =>
        append ? [...prev, ...commentNotifications] : commentNotifications
        );
        setCommentSkip(skip + commentNotifications.length);
        setCommentHasMore(hasMore);
    } catch (err) {
        console.error("Error fetching comment notifications:", err);
    }
    };

/*
    useEffect(() => {
    const fetchCounts = async () => {
        try {
        const res = await axios.get("/user/new-followers-count");
        setNewFollowersCount(res.data.newFollowersCount);
        // Combine into total notification count
        setNotificationsCount(prev => prev + res.data.newFollowersCount);
        } catch (err) {
        console.error("Error fetching new followers:", err);
        }
    };
    fetchCounts();
    }, []);
*/
    useEffect(() => {
        const fetchCounts = async () => {
            try {
            // Fetch new followers count
            const followersRes = await axios.get("/user/new-followers-count");
            setNewFollowersCount(followersRes.data.newFollowersCount);

            // Fetch new upvotes count
            const upvotesRes = await axios.get("/user/new-upvotes-count");
            setNewUpvoteCount(upvotesRes.data.newUpvoteCount);

            // Fetch new comments count
            const commentsRes = await axios.get("/user/new-comments-count");
            setNewCommentsCount(commentsRes.data.newCommentsCount);

            // Combine into total notifications count 
            setNotificationsCount(
                followersRes.data.newFollowersCount + upvotesRes.data.newUpvoteCount + commentsRes.data.newCommentsCount
            );
            } catch (err) {
            console.error("Error fetching notification counts:", err);
            }
        };

        fetchCounts();
    }, []);


    // Fetch unread messages periodically
    useEffect(() => {
        const fetchUnread = async () => {
            try {
                const res = await axios.get("/messages/unread-count");
                setUnreadCount(res.data.count);
            } catch (err) {
                console.error("Error fetching unread count:", err);
            }
        };

        fetchUnread(); // initial fetch
        const interval = setInterval(fetchUnread, 5000); // refresh every 5s
        return () => clearInterval(interval);
    }, []);
    /*
    useEffect(() => {
        const fetchUnreadByUser = async () => {
            try {
                const res = await axios.get("/messages/unread-by-user");
                // convert array → map: { userId: count }
                const map = {};
                res.data.forEach(u => {
                    map[u.userId] = u.count;
                });
                setUnreadByUser(map);
            } catch (err) {
                console.error("Error fetching unread counts by user:", err);
            }
        };

        fetchUnreadByUser();
        const interval = setInterval(fetchUnreadByUser, 5000);
        return () => clearInterval(interval);
    }, []);
    */

    // Fetch unread counts every few seconds
    useEffect(() => {
        const fetchUnread = async () => {
            try {
                // Get total unread messages
                const totalRes = await axios.get("/messages/unread-count");
                setUnreadCount(totalRes.data.count || 0);

                // Get per-user unread counts
                const userRes = await axios.get("/messages/unread-by-user");
                // Convert array → map { userId: count }
                const unreadMap = {};
                userRes.data.forEach(u => unreadMap[u.userId] = u.count);
                setUnreadByUser(unreadMap);

            } catch (err) {
                console.error("Error fetching unread data:", err);
            }
        };

        fetchUnread();
        const interval = setInterval(fetchUnread, 5000);
        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        axios.get("/messages/conversations")
        .then(res => setConversations(res.data))
        .catch(err => console.error("Failed to load conversations", err));
    }, []);

    // Fetch messages whenever a user is selected
    useEffect(() => {
        if (!selectedUser?._id) return;

        axios
            .get(`/messages/${selectedUser._id}`)
            .then((res) => {
            setMessages(res.data);
            })
            .catch((err) => console.error("Error fetching messages:", err));
    }, [selectedUser]);

    useEffect(() => {
        if (!userId) return;
        // Get recipient username
        //axios.get(`/user/view/${userId}`).then(res => setUsername(res.data.username));

        // Load existing conversation
        axios.get(`/messages/${userId}`)
            .then(res => setMessages(res.data))
            .catch(err => console.error("Failed to load messages:", err));
    }, [userId]);


    const handleFollowToggle = async (e, targetId) => {
        e.stopPropagation();
        try {
        if (followingMap[targetId]) {
            // Unfollow
            await axios.post(`/user/unfollow/${targetId}`);
            setFollowingMap((prev) => ({ ...prev, [targetId]: false }));
        } else {
            // Follow
            await axios.post(`/user/follow/${targetId}`);
            setFollowingMap((prev) => ({ ...prev, [targetId]: true }));
        }
        } catch (err) {
        console.error("Follow/Unfollow error:", err);
        }
    };

    const handleSendMessage = async () => {
        if (!newMessage.trim() || !selectedUser) return;
        try {
        const res = await axios.post(`/messages/send/${selectedUser._id}`, { content: newMessage });
        setMessages(prev => [...prev, res.data]);
        setNewMessage("");
        } catch (err) {
        console.error("Failed to send message:", err);
        }
    };

    // handle search requests
    // Auto search when user types
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);

        // Clear previous timer to debounce API calls
        if (typingTimeout) clearTimeout(typingTimeout);

        setTypingTimeout(
        setTimeout(() => {
            if (value.trim()) {
            axios
                .get(`/user/search?username=${value}`)
                .then((res) => setResults(res.data))
                .catch((err) => console.error("Search failed", err));
            } else {
            setResults([]);
            }
        }, 300) // wait 300ms after typing stops
        );
    };

    // go to selected profile
    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const isNavigable = (id, content, deletedPlaceholder) =>
        !!id && !!content && content !== deletedPlaceholder;

  return (
    <div
            style={{
                //padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >
            {/* Top Bar: Buttons in center, search bar at top-right */}
            {/*<div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '30px',
            }}
            >*/}
            {/* Empty space on the left for symmetry */}
            {/*<div style={{ width: '260px' }}></div>*/}

            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1200,
                    backgroundColor: "#FFFDF8",
                    //borderBottom: "1px solid rgba(0,0,0,0.08)",
                    px: 3,
                    py: 2
                }}
                >
                <Box
                    sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                    }}
                >

                    {/* Left spacer for symmetry */}
                    {/*<Box sx={{ width: 260 }} />*/}
                    <Box
            sx={{
                display: "flex",
                alignItems: "center",
                minWidth: 220, // keeps layout stable
            }}
        >
            <Tooltip
                title="Lady Wisdom"
                arrow
                followCursor
            >
                <Box
                    component="img"
                    src={logo}
                    alt="Colloquia Logo"
                    onClick={() => history.push("/home")}
                    sx={{
                        height: 125,
                        width: "auto",
                        borderRadius: "10px", // rounded edges
                        cursor: "pointer",
                        objectFit: "contain",
                    }}
                />
            </Tooltip>
        </Box>

            {/* Centered Buttons */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/mainsocial/following')}
                    >
                        Main Social
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/Government/following')}
                    >
                        Government
                    </Button>
                    {/*<Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page3')}
                    >
                        Journalism
                    </Button>*/}
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/audiovisual')}
                    >
                        Voting Power
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/profile')}
                    >
                        Profile
                    </Button>
                </Box>
   
            {/* Right Section: Notifications + Chat + Search */}
            <Box
                sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5, // spacing between circle buttons and search bar
                }}
            >
                <Badge
                    badgeContent={notificationsCount > 0 ? notificationsCount : null}
                    color="error"
                    overlap="circular"
                    //sx={{
                    //    position: "absolute",
                    //    bottom: -4,
                    //    left: "50%",
                     //   transform: "translateX(-50%)",
                    //}}
                    sx={{
                        position: "relative", // let Badge control its internal layout
                        "& .MuiBadge-badge": {
                        top: 4,      // adjust position of red bubble
                        right: 4,
                        }
                    }}
                >
                    {/* Notifications Circle Button */}
                    <Button
                        sx={{
                        width: 42,
                        height: 42,
                        minWidth: 42,
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        "&:hover": {
                            backgroundColor: "#f5f5f5",
                        },
                        }}
                        onClick={() => history.push("/notificationsPage")}
                    >
                        <Box
                            component="img"
                            src={notificationIcon}
                            alt="Notifications"
                            sx={{
                                width: 20,     // control icon size
                                height: 20,
                                objectFit: "contain",
                                pointerEvents: "none", // prevents weird click behavior
                            }}
                        />
                    </Button>
                </Badge>
                {/* Chat Circle Button */}
                {/*<Button
                    sx={{
                    width: 42,
                    height: 42,
                    minWidth: 42,
                    borderRadius: "50%",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    "&:hover": {
                        backgroundColor: "#f5f5f5",
                    },
                    }}
                    onClick={() => history.push("/directmessage")}
                >

                </Button>*/}
                <Badge
                    badgeContent={unreadCount > 0 ? unreadCount : null}
                    color="error"
                    overlap="circular"
                    //sx={{
                    //    position: "absolute",
                    //    bottom: -4,
                    //    left: "50%",
                     //   transform: "translateX(-50%)",
                    //}}
                    sx={{
                        position: "relative", // let Badge control its internal layout
                        "& .MuiBadge-badge": {
                        top: 4,      // adjust position of red bubble
                        right: 4,
                        }
                    }}
                >
                    <Button
                        sx={{
                        width: 42,
                        height: 42,
                        minWidth: 42,
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                        onClick={() => {
                            setUnreadCount(0); // optionally reset when clicked
                            history.push("/directmessage");
                        }}
                    >
                        <Box
                            component="img"
                            src={dmIcon}
                            alt="Messages"
                            sx={{
                                width: 20,
                                height: 20,
                                objectFit: "contain",
                                pointerEvents: "none",
                            }}
                        />
                    </Button>
                </Badge>
            {/* Search Bar - Top Right */}
            <Box
                sx={{
                    position: 'relative', // parent container for absolute dropdown
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: 1,
                }}
            >
                <TextField
                    placeholder="Search"
                    variant="outlined"
                    size="small"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    sx={{
                    borderRadius: '20px',
                    backgroundColor: '#fff',
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '20px',
                        padding: '0px 8px',
                    },
                    width: '180px',
                    }}
                />

                {/* Search Results - Absolutely positioned */}
                {/*{results.length > 0 && (
                    <List
                    sx={{
                        position: 'absolute',
                        top: '100%', // directly below the search bar
                        right: 0,    // align to right of search bar
                        width: '200px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        backgroundColor: '#fafafa',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        zIndex: 10,
                        mt: 0.5,
                    }}
                    >
                    {results.map((user) => (
                        <ListItem
                        key={user._id}
                        button
                        onClick={() => visitProfile(user._id)}
                        sx={{
                            padding: '5px 10px',
                            '&:hover': { backgroundColor: '#eee' },
                        }}
                        >
                        <ListItemText
                            primary={user.username}
                            secondary={`${user.first_name} ${user.last_name}`}
                        />
                        </ListItem>
                    ))}
                    </List>
                )}*/}
                {results.length > 0 && (
                    <List
                    sx={{
                        position: 'absolute',
                        top: '100%', // directly below the search bar
                        right: 0,    // align to right of search bar
                        width: '200px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        backgroundColor: '#fafafa',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        zIndex: 10,
                        mt: 0.5,
                    }}
                    >
                {results.map((user) => (
                    <ListItemButton
                        key={user._id}
                        onClick={() => visitProfile(user._id)}
                        sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        px: 1.5,
                        py: 1,
                        '&:hover': { backgroundColor: '#eee' },
                        }}
                    >
                        {/* Profile Image */}
                        <Avatar
                        src={user.profileImageUrl}
                        alt={user.username}
                        sx={{ width: 36, height: 36 }}
                        />

                        {/* Text stack */}
                        <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
                        
                        {/* Full Name (top) */}
                        <Typography
                            sx={{
                            fontSize: "0.9rem",
                            fontWeight: 500,
                            color: "#333",
                            lineHeight: 1.2,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            }}
                        >
                            {user.first_name} {user.last_name}
                        </Typography>

                        {/* Username (bottom with @) */}
                        <Typography
                            sx={{
                            fontSize: "0.8rem",
                            color: "#666",
                            lineHeight: 1.2,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            }}
                        >
                            @{user.username}
                        </Typography>

                        </Box>
                    </ListItemButton>
                    ))}
                     </List>
                )}
            </Box>
            </Box>
            </Box>
            </Box>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center", // center horizontally on screen
                    alignItems: "flex-start", // align top
                    minHeight: "100vh",
                    padding: "20px",
                }}
                >
                {/* Sidebar */}
                <Box
                    sx={{
                        position: "fixed",
                        left: 0,
                        width: 250,
                        height: "50vh",
                        borderRight: "1px solid #ccc",
                        overflowY: "auto",
                        zIndex: 10,
                    }}
                >
                    {/*<List disablePadding>
                        {["Follows", "Upvotes", "Comments"].map((label) => (
                            <ListItemButton
                            key={label}
                            sx={{
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                p: 2,
                                borderBottom: "1px solid #ddd",
                                "&:hover": {
                                backgroundColor: "#f0f0f0",
                                },
                            }}
                            >
                            <Typography
                                variant="h6"
                                sx={{
                                    textAlign: "center",
                                    width: "100%",
                                    fontWeight: 500,
                                }}
                            >
                                {label}
                            </Typography>
                            </ListItemButton>
                        ))}
                        </List>*/}
                        <List disablePadding>
                            {["Follows", "Power Votes", "Comments"].map((label) => (
                                <ListItemButton
                                key={label}
                                sx={{
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    p: 2,
                                    borderBottom: "1px solid #ddd",
                                    "&:hover": {
                                    backgroundColor: "#f0f0f0",
                                    },
                                }}
                                /*
                                onClick={() => {
                                    if (label === "Follows") {
                                    axios.post("/user/reset-new-followers"); // clear count when opened
                                    setNewFollowersCount(0);
                                    }
                                }}*/
                               /*onClick={async () => {
                                    setActiveSection(label);

                                    if (label === "Follows") {
                                        try {
                                            const res = await axios.get("/user/follow-notifications");
                                            setFollowNotifications(res.data.followNotifications || []);
                                            await axios.post("/user/reset-new-followers");
                                            setNewFollowersCount(0);
                                        } catch (err) {
                                            console.error("Error fetching follow notifications:", err);
                                        }
                                    }

                                    if (label === "Power Votes") {
                                        try {
                                            const res = await axios.get("/user/upvote-notifications");
                                            setUpvoteNotifications(res.data.upvoteNotifications || []);
                                            await axios.post("/user/reset-new-upvotes");
                                            setNewUpvoteCount(0);
                                        } catch (err) {
                                            console.error("Error fetching upvote notifications:", err);
                                        }
                                    }

                                    if (label === "Comments") {
                                        try {
                                            const res = await axios.get("/user/comment-notifications");
                                            setCommentNotifications(res.data.commentNotifications || []);
                                            await axios.post("/user/reset-new-comments"); // optional reset endpoint
                                            setNewCommentsCount(0);
                                        } catch (err) {
                                            console.error("Error fetching comment notifications:", err);
                                        }
                                    }

                                }}*/
                               onClick={async () => {
                                    setActiveSection(label);

                                    if (label === "Follows") {
                                        setFollowSkip(0);
                                        setFollowHasMore(false);
                                        setFollowNotifications([]);
                                        await fetchFollowNotifications(0, false);
                                        await axios.post("/user/reset-new-followers");
                                        setNewFollowersCount(0);
                                    }
                                    if (label === "Power Votes") {
                                        setUpvoteSkip(0);
                                        setUpvoteHasMore(false);
                                        setUpvoteNotifications([]);
                                        await fetchUpvoteNotifications(0, false);
                                        await axios.post("/user/reset-new-upvotes");
                                        setNewUpvoteCount(0);
                                    }
                                    if (label === "Comments") {
                                        setCommentSkip(0);
                                        setCommentHasMore(false);
                                        setCommentNotifications([]);
                                        await fetchCommentNotifications(0, false);
                                        await axios.post("/user/reset-new-comments");
                                        setNewCommentsCount(0);
                                    }
                                }}
                                >
                                <Box sx={{ position: "relative", width: "100%", textAlign: "center" }}>
                                    {/*
                                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                                    {label}
                                    </Typography>

                                    {label === "Follows" && newFollowersCount > 0 && (
                                    <Badge
                                        badgeContent={newFollowersCount}
                                        color="error"
                                        sx={{
                                        position: "absolute",
                                        top: 0,
                                        right: 20,
                                        "& .MuiBadge-badge": {
                                            fontSize: "0.7rem",
                                            height: 20,
                                            minWidth: 20,
                                        },
                                        }}
                                    />
                                    )}

                                    {label === "Upvotes" && newUpvoteCount > 0 && (
                                        <Badge
                                        badgeContent={newUpvoteCount}
                                        color="error"
                                        sx={{
                                            position: "absolute",
                                            top: 0,
                                            right: 20,
                                            "& .MuiBadge-badge": {
                                            fontSize: "0.7rem",
                                            height: 20,
                                            minWidth: 20,
                                            },
                                        }}
                                        />
                                    )}
                                    */}
                                    <Badge
                                        badgeContent={
                                            label === "Follows"
                                            ? newFollowersCount
                                            : label === "Power Votes"
                                            ? newUpvoteCount
                                            : label === "Comments"
                                            ? newCommentsCount
                                            : 0
                                        }
                                        color="error"
                                        invisible={
                                            (label === "Follows" && newFollowersCount === 0) ||
                                            (label === "Power Votes" && newUpvoteCount === 0) ||
                                            (label === "Comments" && newCommentsCount === 0)
                                        }
                                        sx={{
                                            "& .MuiBadge-badge": {
                                            fontSize: "0.7rem",
                                            height: 20,
                                            minWidth: 20,
                                            right: -15, // adjust horizontal offset
                                            top: 4, // adjust vertical offset
                                            },
                                        }}
                                        >
                                        <Typography variant="h6" sx={{ fontWeight: 500 }}>
                                            {label}
                                        </Typography>
                                    </Badge>
                                </Box>
                                </ListItemButton>
                            ))}
                            </List>
                </Box>

                {activeSection === "Follows" && (
                    <>
                    <Box sx={{ width: "100%", mt: 2 }}>
                        {followNotifications.length > 0 ? (
                        <>
                        {followNotifications.map((n, idx) => (
                            <Box 
                                key={`${n._id}-${idx}`}
                                p={2}                // padding inside each post box
                                my={2}               // margin above and below each post box
                                border="1px solid #ccc"  // light border around each post
                                borderRadius="8px"       // rounded corners
                                sx={{
                                    position: "relative",
                                    //maxWidth: 900, // limit width
                                    width: "calc(100% - 770px)",
                                    mx: "auto", // center horizontally
                                    my: 2, // vertical spacing between each post
                                }}
                            >
                                    {/*
                                    <Typography variant="body1">
                                    <strong>@{n.username}</strong> followed you
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                    {new Date(n.created_at).toLocaleString()}
                                    </Typography>
                                    */}
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        sx={{ width: "100%" }}
                                    >
                                    <Box display="flex" alignItems="flex-start" gap={1}>
                                        <Avatar
                                            src={n.profileImageUrl || '/default-avatar.jpg'}
                                            alt={`${n.first_name || ''} ${n.last_name || ''}`}
                                            onClick={(e) => visitProfile(e, n._id)}
                                            sx={{ width: 62, height: 62 }}
                                        />
                                        <Box display="flex" flexDirection="column">
                                        <Box display="flex" alignItems="center" gap={0.75}>
                                            <Typography 
                                                variant="subtitle1" 
                                                fontWeight="bold"
                                                onClick={(e) => visitProfile(e, n._id)}
                                                sx={{
                                                    cursor: "pointer",
                                                    display: "inline-block",
                                                    "&:hover": {
                                                    textDecoration: "underline",
                                                    textDecorationColor: "currentColor", 
                                                    textUnderlineOffset: "3px",
                                                    },
                                                }}
                                            >
                                                {n.first_name && n.last_name
                                                    ? `${n.first_name} ${n.last_name}`
                                                    : 'Unknown Name'}{" "}
                                                    </Typography>
                                                        {/*<Typography
                                                            component="span"
                                                            variant="subtitle1"
                                                            fontWeight="normal"
                                                        >
                                                            followed you
                                                        </Typography>*/}
                                                        <Typography
                                                            component="span"
                                                            variant="subtitle1"
                                                            fontWeight="normal"
                                                            color={n.type === "unfollow" ? "error.main" : "text.primary"}
                                                        >
                                                            {n.type === "unfollow" ? "unfollowed you" : "followed you"}
                                                        </Typography>
                                            </Box>
                                            <Typography 
                                                variant="body2" 
                                                color="text.secondary"
                                                onClick={(e) => visitProfile(e, n._id)}
                                                sx={{
                                                    cursor: "pointer",
                                                    display: "block",
                                                    "&:hover": {
                                                    textDecoration: "underline",
                                                    textDecorationColor: "currentColor",
                                                    textUnderlineOffset: "3px",
                                                    },
                                                }}
                                            >
                                                @{n.username || 'unknown'}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                                {new Date(n.created_at).toLocaleString()} 
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Button
                                        size="small"
                                        //variant="outlined"
                                        variant={followingMap[n._id] ? "contained" : "outlined"}
                                        /*onClick={(e) => {
                                            e.stopPropagation(); 
                                            axios.post(`/user/follow/${n._id}`)
                                                .then(res => alert("Followed!"))
                                                .catch(err => console.error("Follow failed", err));
                                        }}*/
                                        onClick={(e) => handleFollowToggle(e, n._id)}
                                        onMouseEnter={() => setHoveredButton(n._id)}
                                        onMouseLeave={() => setHoveredButton(null)}
                                        sx={{
                                            alignSelf: "center",
                                            minWidth: "80px",
                                            textTransform: "none",

                                            transition: "all 0.2s ease-in-out",
                                            backgroundColor:
                                                followingMap[n._id] && hoveredButton === n._id
                                                ? "error.main"
                                                : followingMap[n._id]
                                                ? "primary.main"
                                                : "transparent",
                                            color:
                                                followingMap[n._id] && hoveredButton === n._id
                                                ? "#fff"
                                                : followingMap[n._id]
                                                ? "#fff"
                                                : "primary.main",
                                            borderColor: "primary.main",
                                            "&:hover": {
                                                backgroundColor:
                                                followingMap[n._id] && hoveredButton === n._id
                                                    ? "error.dark"
                                                    : "primary.light",
                                            },
                                        }}
                                    >
                                        {followingMap[n._id]
                                            ? hoveredButton === n._id
                                                ? "Unfollow"
                                                : "Following"
                                            : "Follow"}
                                    </Button>
                                </Box>
                            </Box>
                            ))}
                            {/* Load More button */}
                            {followHasMore && (
                                <Box display="flex" justifyContent="center" mt={2} mb={4}>
                                    <Button
                                        variant="outlined"
                                        disabled={followLoadingMore}
                                        onClick={async () => {
                                            setFollowLoadingMore(true);
                                            await fetchFollowNotifications(followSkip, true);
                                            setFollowLoadingMore(false);
                                        }}
                                    >
                                        {followLoadingMore ? "Loading..." : "Load More"}
                                    </Button>
                                </Box>
                            )}
                    </>
                        ) : (
                            <Typography variant="body2" color="text.secondary">
                            No new followers yet.
                            </Typography>
                        )}
                    </Box>
                    </>
                )}

                {/*{activeSection === "Power Votes" && (
                    <Box sx={{ width: "100%", mt: 2 }}>
                        {upvoteNotifications.length > 0 ? (
                    <>
                        {upvoteNotifications.map((n, idx) => (
                            <Box 
                                key={`${n._id}-${idx}`}
                                p={2}
                                my={2}
                                border="1px solid #ccc"
                                borderRadius="8px"
                                sx={{
                                position: "relative",
                                width: "calc(100% - 770px)",
                                mx: "auto",
                                my: 2,
                                }}
                            >
                                <Box display="flex" alignItems="center" gap={1}>
                                <Avatar
                                    src={n.profileImageUrl || '/default-avatar.jpg'}
                                    alt={`${n.first_name || ''} ${n.last_name || ''}`}
                                    onClick={(e) => visitProfile(e, n._id)}
                                    sx={{ width: 62, height: 62 }}
                                />
                                <Box>
                                    <Typography 
                                        variant="subtitle1" 
                                        fontWeight="bold"
                                        onClick={(e) => visitProfile(e, n._id)}
                                        sx={{
                                            cursor: "pointer",
                                            display: "inline-block",
                                            "&:hover": {
                                                textDecoration: "underline",
                                                textDecorationColor: "currentColor", 
                                                textUnderlineOffset: "3px",
                                            },
                                        }}
                                    >
                                        {n.first_name && n.last_name
                                            ? `${n.first_name} ${n.last_name}`
                                            : 'Unknown Name'}{" "}
                                    </Typography>
                                    
                                    <Box
                                        component="span"
                                        sx={{
                                            display: "inline-block",
                                            px: 0.5,
                                            borderRadius: "4px",
                                            //cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "#d9e4f0", 
                                                //cursor: n.postContent && n.postContent !== '[Post deleted]' ? 'pointer' : 'default',
                                                cursor:
                                                (n.postContent && n.postContent !== "[Post deleted]") ||
                                                (n.govPostReplyId && n.govPostReplyContent !== "[Reply deleted]") ||
                                                (n.govPostCommentId && n.govPostCommentContent !== "[Comment deleted]") ||
                                                (n.govPostId && n.govPostContent !== "[Post deleted]") ||
                                                (n.photoId && n.photoDescription !== "[Photo deleted]") ||
                                                (n.videoId && n.videoTitle !== "[Video deleted]") ||
                                                (n.commentId && n.commentContent !== "[Comment deleted]") ||
                                                (n.billCommentId && n.billCommentContent !== "[Bill Comment deleted]") ||
                                                (n.scotusCommentId && n.scotusCommentContent !== "[SCOTUS Comment deleted]") ||
                                                (n.calBillCommentId && n.calBillCommentContent !== "[California Bill Comment deleted]") ||
                                                (n.photoCommentId && n.photoCommentContent !== "[Photo Comment deleted]") ||
                                                (n.videoCommentId && n.videoCommentContent !== "[Video Comment deleted]")
                                                ? "pointer"
                                                : "default",
                                            },
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (n.govPostReplyId && n.govPostReplyContent !== "[Reply deleted]") {
                                                history.push(`/govPost/${n.govPostId}/comments/${n.govPostCommentId}?reply=${n.govPostReplyId}`);
                                            } else if (n.govPostCommentId && n.govPostCommentContent !== "[Comment deleted]") {
                                                history.push(`/govPost/${n.govPostId}/comments/${n.govPostCommentId}`);
                                            } else if (n.govPostId && n.govPostContent !== "[Post deleted]") {
                                                history.push(`/govPost/${n.govPostId}/comments`);
                                            } else if (n.commentId && n.commentContent !== "[Comment deleted]") {
                                                history.push(`/mainSocial/${n.postId}/comments/${n.commentId}`);
                                            } else if (n.postContent && n.postContent !== '[Post deleted]') {
                                                history.push(`/post/${n.postId}/comments`)
                                            } else if (n.photoCommentId && n.photoCommentContent !== "[Photo Comment deleted]") {
                                                history.push(`/photo/${n.photoId}/comments/${n.photoCommentId}`);
                                            } else if (n.videoCommentId && n.videoCommentContent !== "[Video Comment deleted]") {
                                                history.push(`/video/${n.videoId}/comments/${n.videoCommentId}`);
                                            } else if (n.photoId && n.photoDescription !== "[Photo deleted]") {
                                                history.push(`/photos/${n.photoId}/comments`);
                                            } else if (n.videoId && n.videoTitle !== "[Video deleted]") {
                                                history.push(`/videos/${n.videoId}/comments`);
                                            } else if (n.billCommentId && n.billCommentContent !== "[Bill Comment deleted]") {
                                                history.push(`/bill/${n.billId}/comments/${n.billCommentId}`);
                                            } else if (n.scotusCommentId && n.scotusCommentContent !== "[SCOTUS Comment deleted]") {
                                                history.push(`/scotusCase/${n.scotusId}/comments/${n.scotusCommentId}`);
                                            } else if (n.calBillCommentId && n.calBillCommentContent !== "[California Bill Comment deleted]") {
                                                history.push(`/calBill/${n.calBillId}/comments/${n.calBillCommentId}`);
                                            } else if (n.stateLegislatureCommentId && n.stateLegislatureCommentContent !== "[Comment deleted]") {
                                                history.push(`/Government/Elections/StateLegislatureElections/${n.stateLegislatureId}/comments/${n.stateLegislatureCommentId}`);
                                            } else if (n.statewideOfficeCommentId && n.statewideOfficeCommentContent !== "[Comment deleted]") {
                                                history.push(`/Government/Elections/StatewideOfficesElections/${n.statewideOfficeId}/comments/${n.statewideOfficeCommentId}`);
                                            } else if (n.gubernatorialElectionsCommentId && n.gubernatorialElectionsCommentContent !== "[Comment deleted]") {
                                                history.push(`/Government/Elections/GubernatorialElections/${n.gubernatorialElectionsId}/comments/${n.gubernatorialElectionsCommentId}`);
                                            } else if (n.usSenateCommentId && n.usSenateCommentContent !== "[Comment deleted]") {
                                                history.push(`/Government/Elections/USSenateElections/${n.usSenateId}/comments/${n.usSenateCommentId}`);
                                            } else if (n.pollCommentId && n.pollCommentContent !== "[Comment deleted]") {
                                                history.push(`/Government/Elections/USHouseOfRepElections/${n.pollId}/comments/${n.pollCommentId}`);
                                            }
                                        }}
                                    >
                                        <Typography component="span" variant="body1" color="black">
                                            {n.govPostReplyId
                                                ? "power voted your reply:"
                                                : n.govPostCommentId
                                                ? "power voted your comment:"
                                                : n.govPostId
                                                ? "power voted your post:"
                                                : n.pollCommentId
                                                ? "power voted your comment:"
                                                : n.usSenateCommentId
                                                ? "power voted your comment:"
                                                : n.gubernatorialElectionsCommentId
                                                ? "power voted your comment:"
                                                : n.statewideOfficeCommentId
                                                ? "power voted your comment:"
                                                : n.stateLegislatureCommentId
                                                ? "power voted your comment:"
                                                : n.videoCommentId
                                                ? "power voted your comment:"
                                                : n.photoCommentId
                                                ? "power voted your comment:"
                                                : n.calBillCommentId
                                                ? "power voted your comment:"
                                                : n.scotusCommentId
                                                ? "power voted your comment:"
                                                : n.billCommentId
                                                ? "power voted your comment:"
                                                : n.commentId
                                                ? "power voted your comment:"
                                                : n.videoId
                                                ? "power voted your video:"
                                                : n.photoId
                                                ? "power voted your photo:"
                                                : "power voted your post:"}
                                        </Typography>

                                        <Typography
                                            component="span"
                                            variant="body1"
                                            color="text.secondary"
                                            sx={{
                                                ml: 0.5,
                                                textDecoration: "none",
                                                "&:hover": { textDecoration: "none" },
                                            }}
                                        >
                                            {" "}
                                            "
                                            {n.govPostReplyId
                                                ? n.govPostReplyContent?.trim() || "[Reply deleted]"
                                                : n.govPostCommentId
                                                ? n.govPostCommentContent?.trim() || "[Comment deleted]"
                                                : n.govPostId
                                                ? n.govPostContent?.trim() || "[Post deleted]"
                                                : n.pollCommentId
                                                ? n.pollCommentContent || "[Comment deleted]"
                                                : n.usSenateCommentId
                                                ? n.usSenateCommentContent || "[Comment deleted]"
                                                : n.gubernatorialElectionsCommentId
                                                ? n.gubernatorialElectionsCommentContent || "[Comment deleted]"
                                                : n.statewideOfficeCommentId
                                                ? n.statewideOfficeCommentContent || "[Comment deleted]"
                                                : n.stateLegislatureCommentId
                                                ? n.stateLegislatureCommentContent || "[Comment deleted]"
                                                : n.videoCommentId
                                                ? n.videoCommentContent || "[Video Comment deleted]"
                                                : n.photoCommentId
                                                ? n.photoCommentContent || "[Photo Comment deleted]"
                                                : n.calBillCommentId
                                                ? n.calBillCommentContent || "[California Bill Comment deleted]"
                                                : n.scotusCommentId
                                                ? n.scotusCommentContent || "[SCOTUS Comment deleted]"
                                                : n.billCommentId
                                                ? n.billCommentContent || "[Bill Comment deleted]"
                                                : n.commentId
                                                ? n.commentContent || "[Comment deleted]"
                                                : n.videoId
                                                ? n.videoTitle || "[Video deleted]"
                                                : n.photoId
                                                ? n.photoDescription || "[Photo deleted]"
                                                : n.postContent || "[Post deleted]"}
                                            "
                                        </Typography>
                                       
                                    </Box>
                                    
                                    <Typography 
                                        variant="body2" 
                                        color="text.secondary"
                                        onClick={(e) => visitProfile(e, n._id)}
                                        sx={{
                                            cursor: "pointer",
                                            display: "block",
                                            "&:hover": {
                                                textDecoration: "underline",
                                                textDecorationColor: "currentColor",
                                                textUnderlineOffset: "3px",
                                            },
                                        }}
                                    >
                                        @{n.username || 'unknown'}
                                    </Typography>
                                    <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ display: "block", mt: 0.5 }}
                                    >
                                    {new Date(n.created_at).toLocaleString()}
                                    </Typography>
                                </Box>
                                </Box>
                            </Box>
                            ))}
                            {upvoteHasMore && (
                                <Box display="flex" justifyContent="center" mt={2} mb={4}>
                                    <Button
                                    variant="outlined"
                                    disabled={upvoteLoadingMore}
                                    onClick={async () => {
                                        setUpvoteLoadingMore(true);
                                        await fetchUpvoteNotifications(upvoteSkip, true);
                                        setUpvoteLoadingMore(false);
                                    }}
                                    >
                                    {upvoteLoadingMore ? "Loading..." : "Load More"}
                                    </Button>
                                </Box>
                                )}
                            </>
                        ) : (
                        <Typography variant="body2" color="text.secondary">
                            No upvotes yet.
                        </Typography>
                        )}
                    </Box>
                    )}*/}
                    {activeSection === "Power Votes" && (
                        <Box sx={{ width: "100%", mt: 2 }}>
                        {upvoteNotifications.length > 0 ? (
                            <>
                            {upvoteNotifications.map((n, idx) => {

                                {/* ✏️ CHANGED: compute canNavigate with isNavigable() — requires non-null ID
                                    AND non-placeholder content. Old code only checked content strings,
                                    so null IDs still caused navigation to /post/undefined/comments. */}
                                const canNavigate =
                                isNavigable(n.postId,                          n.postContent,                         "[Post deleted]")                    ||
                                isNavigable(n.commentId,                       n.commentContent,                      "[Comment deleted]")                 ||
                                isNavigable(n.photoId,                         n.photoDescription,                    "[Photo deleted]")                   ||
                                isNavigable(n.photoCommentId,                  n.photoCommentContent,                 "[Photo Comment deleted]")           ||
                                isNavigable(n.videoId,                         n.videoTitle,                          "[Video deleted]")                   ||
                                isNavigable(n.videoCommentId,                  n.videoCommentContent,                 "[Video Comment deleted]")           ||
                                isNavigable(n.govPostId,                       n.govPostContent,                      "[Post deleted]")                    ||
                                isNavigable(n.govPostCommentId,                n.govPostCommentContent,               "[Comment deleted]")                 ||
                                isNavigable(n.govPostReplyId,                  n.govPostReplyContent,                 "[Reply deleted]")                   ||
                                isNavigable(n.billCommentId,                   n.billCommentContent,                  "[Bill Comment deleted]")            ||
                                isNavigable(n.scotusCommentId,                 n.scotusCommentContent,                "[SCOTUS Comment deleted]")          ||
                                isNavigable(n.calBillCommentId,                n.calBillCommentContent,               "[California Bill Comment deleted]") ||
                                isNavigable(n.stateLegislatureCommentId,       n.stateLegislatureCommentContent,      "[Comment deleted]")                 ||
                                isNavigable(n.statewideOfficeCommentId,        n.statewideOfficeCommentContent,       "[Comment deleted]")                 ||
                                isNavigable(n.gubernatorialElectionsCommentId, n.gubernatorialElectionsCommentContent,"[Comment deleted]")                 ||
                                isNavigable(n.usSenateCommentId,               n.usSenateCommentContent,              "[Comment deleted]")                 ||
                                isNavigable(n.pollCommentId,                   n.pollCommentContent,                  "[Comment deleted]");

                                {/* ✏️ CHANGED: extracted click logic into named handler.
                                    Added `if (!canNavigate) return;` as first line — hard stop that
                                    prevents any history.push when the referenced content is deleted.
                                    All branch conditions now use isNavigable() instead of raw string checks. */}
                                const handleUpvoteClick = (e) => {
                                e.stopPropagation();
                                if (!canNavigate) return;

                                if (isNavigable(n.govPostReplyId, n.govPostReplyContent, "[Reply deleted]")) {
                                    history.push(`/govPost/${n.govPostId}/comments/${n.govPostCommentId}?reply=${n.govPostReplyId}`);
                                } else if (isNavigable(n.govPostCommentId, n.govPostCommentContent, "[Comment deleted]")) {
                                    history.push(`/govPost/${n.govPostId}/comments/${n.govPostCommentId}`);
                                } else if (isNavigable(n.govPostId, n.govPostContent, "[Post deleted]")) {
                                    history.push(`/govPost/${n.govPostId}/comments`);
                                } else if (isNavigable(n.commentId, n.commentContent, "[Comment deleted]")) {
                                    history.push(`/mainSocial/${n.postId}/comments/${n.commentId}`);
                                } else if (isNavigable(n.postId, n.postContent, "[Post deleted]")) {
                                    history.push(`/post/${n.postId}/comments`);
                                } else if (isNavigable(n.photoCommentId, n.photoCommentContent, "[Photo Comment deleted]")) {
                                    history.push(`/photo/${n.photoId}/comments/${n.photoCommentId}`);
                                } else if (isNavigable(n.videoCommentId, n.videoCommentContent, "[Video Comment deleted]")) {
                                    history.push(`/video/${n.videoId}/comments/${n.videoCommentId}`);
                                } else if (isNavigable(n.photoId, n.photoDescription, "[Photo deleted]")) {
                                    history.push(`/photos/${n.photoId}/comments`);
                                } else if (isNavigable(n.videoId, n.videoTitle, "[Video deleted]")) {
                                    history.push(`/videos/${n.videoId}/comments`);
                                } else if (isNavigable(n.billCommentId, n.billCommentContent, "[Bill Comment deleted]")) {
                                    history.push(`/bill/${n.billId}/comments/${n.billCommentId}`);
                                } else if (isNavigable(n.scotusCommentId, n.scotusCommentContent, "[SCOTUS Comment deleted]")) {
                                    history.push(`/scotusCase/${n.scotusId}/comments/${n.scotusCommentId}`);
                                } else if (isNavigable(n.calBillCommentId, n.calBillCommentContent, "[California Bill Comment deleted]")) {
                                    history.push(`/calBill/${n.calBillId}/comments/${n.calBillCommentId}`);
                                } else if (isNavigable(n.stateLegislatureCommentId, n.stateLegislatureCommentContent, "[Comment deleted]")) {
                                    history.push(`/Government/Elections/StateLegislatureElections/${n.stateLegislatureId}/comments/${n.stateLegislatureCommentId}`);
                                } else if (isNavigable(n.statewideOfficeCommentId, n.statewideOfficeCommentContent, "[Comment deleted]")) {
                                    history.push(`/Government/Elections/StatewideOfficesElections/${n.statewideOfficeId}/comments/${n.statewideOfficeCommentId}`);
                                } else if (isNavigable(n.gubernatorialElectionsCommentId, n.gubernatorialElectionsCommentContent, "[Comment deleted]")) {
                                    history.push(`/Government/Elections/GubernatorialElections/${n.gubernatorialElectionsId}/comments/${n.gubernatorialElectionsCommentId}`);
                                } else if (isNavigable(n.usSenateCommentId, n.usSenateCommentContent, "[Comment deleted]")) {
                                    history.push(`/Government/Elections/USSenateElections/${n.usSenateId}/comments/${n.usSenateCommentId}`);
                                } else if (isNavigable(n.pollCommentId, n.pollCommentContent, "[Comment deleted]")) {
                                    history.push(`/Government/Elections/USHouseOfRepElections/${n.pollId}/comments/${n.pollCommentId}`);
                                }
                                };

                                return (
                                <Box
                                    key={`${n._id}-${idx}`}
                                    p={2} my={2} border="1px solid #ccc" borderRadius="8px"
                                    sx={{ position: "relative", width: "calc(100% - 770px)", mx: "auto", my: 2 }}
                                >
                                    <Box display="flex" alignItems="center" gap={1}>
                                    <Avatar src={n.profileImageUrl || '/default-avatar.jpg'} alt={`${n.first_name || ''} ${n.last_name || ''}`}
                                        onClick={(e) => visitProfile(e, n._id)} sx={{ width: 62, height: 62 }} />
                                    <Box>
                                        <Typography variant="subtitle1" fontWeight="bold" onClick={(e) => visitProfile(e, n._id)}
                                        sx={{ cursor: "pointer", display: "inline-block", "&:hover": { textDecoration: "underline", textDecorationColor: "currentColor", textUnderlineOffset: "3px" } }}>
                                        {n.first_name && n.last_name ? `${n.first_name} ${n.last_name}` : 'Unknown Name'}{" "}
                                        </Typography>

                                        {/* ✏️ CHANGED: onClick now calls handleUpvoteClick (which hard-stops when
                                            !canNavigate). cursor and hover background are driven by canNavigate
                                            instead of the old inline multi-condition string checks. */}
                                        <Box
                                        component="span"
                                        onClick={handleUpvoteClick}
                                        sx={{
                                            display: "inline-block",
                                            px: 0.5,
                                            borderRadius: "4px",
                                            cursor: canNavigate ? "pointer" : "default",
                                            "&:hover": {
                                            backgroundColor: canNavigate ? "#d9e4f0" : "transparent",
                                            },
                                        }}
                                        >
                                        <Typography component="span" variant="body1" color="black">
                                            {n.govPostReplyId
                                            ? "power voted your reply:"
                                            : n.govPostCommentId
                                            ? "power voted your comment:"
                                            : n.govPostId
                                            ? "power voted your post:"
                                            : n.pollCommentId
                                            ? "power voted your comment:"
                                            : n.usSenateCommentId
                                            ? "power voted your comment:"
                                            : n.gubernatorialElectionsCommentId
                                            ? "power voted your comment:"
                                            : n.statewideOfficeCommentId
                                            ? "power voted your comment:"
                                            : n.stateLegislatureCommentId
                                            ? "power voted your comment:"
                                            : n.videoCommentId
                                            ? "power voted your comment:"
                                            : n.photoCommentId
                                            ? "power voted your comment:"
                                            : n.calBillCommentId
                                            ? "power voted your comment:"
                                            : n.scotusCommentId
                                            ? "power voted your comment:"
                                            : n.billCommentId
                                            ? "power voted your comment:"
                                            : n.commentId
                                            ? "power voted your comment:"
                                            : n.videoId
                                            ? "power voted your video:"
                                            : n.photoId
                                            ? "power voted your photo:"
                                            : "power voted your post:"}
                                        </Typography>
                                        <Typography component="span" variant="body1" color="text.secondary"
                                            sx={{ ml: 0.5, textDecoration: "none", "&:hover": { textDecoration: "none" } }}>
                                            {" "}"
                                            {n.govPostReplyId
                                            ? n.govPostReplyContent?.trim() || "[Reply deleted]"
                                            : n.govPostCommentId
                                            ? n.govPostCommentContent?.trim() || "[Comment deleted]"
                                            : n.govPostId
                                            ? n.govPostContent?.trim() || "[Post deleted]"
                                            : n.pollCommentId
                                            ? n.pollCommentContent || "[Comment deleted]"
                                            : n.usSenateCommentId
                                            ? n.usSenateCommentContent || "[Comment deleted]"
                                            : n.gubernatorialElectionsCommentId
                                            ? n.gubernatorialElectionsCommentContent || "[Comment deleted]"
                                            : n.statewideOfficeCommentId
                                            ? n.statewideOfficeCommentContent || "[Comment deleted]"
                                            : n.stateLegislatureCommentId
                                            ? n.stateLegislatureCommentContent || "[Comment deleted]"
                                            : n.videoCommentId
                                            ? n.videoCommentContent || "[Video Comment deleted]"
                                            : n.photoCommentId
                                            ? n.photoCommentContent || "[Photo Comment deleted]"
                                            : n.calBillCommentId
                                            ? n.calBillCommentContent || "[California Bill Comment deleted]"
                                            : n.scotusCommentId
                                            ? n.scotusCommentContent || "[SCOTUS Comment deleted]"
                                            : n.billCommentId
                                            ? n.billCommentContent || "[Bill Comment deleted]"
                                            : n.commentId
                                            ? n.commentContent || "[Comment deleted]"
                                            : n.videoId
                                            ? n.videoTitle || "[Video deleted]"
                                            : n.photoId
                                            ? n.photoDescription || "[Photo deleted]"
                                            : n.postContent || "[Post deleted]"}
                                            "
                                        </Typography>
                                        </Box>

                                        <Typography variant="body2" color="text.secondary" onClick={(e) => visitProfile(e, n._id)}
                                        sx={{ cursor: "pointer", display: "block", "&:hover": { textDecoration: "underline", textDecorationColor: "currentColor", textUnderlineOffset: "3px" } }}>
                                        @{n.username || 'unknown'}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                        {new Date(n.created_at).toLocaleString()}
                                        </Typography>
                                    </Box>
                                    </Box>
                                </Box>
                                );
                            })}
                            {upvoteHasMore && (
                                <Box display="flex" justifyContent="center" mt={2} mb={4}>
                                <Button variant="outlined" disabled={upvoteLoadingMore}
                                    onClick={async () => { setUpvoteLoadingMore(true); await fetchUpvoteNotifications(upvoteSkip, true); setUpvoteLoadingMore(false); }}>
                                    {upvoteLoadingMore ? "Loading..." : "Load More"}
                                </Button>
                                </Box>
                            )}
                            </>
                        ) : (
                            <Typography variant="body2" color="text.secondary">No upvotes yet.</Typography>
                        )}
                        </Box>
                    )}

                    {/*{activeSection === "Comments" && (
                    <Box sx={{ width: "100%", mt: 2 }}>
                        {commentNotifications.length > 0 ? (
                        <>
                            {commentNotifications.map((n, idx) => (
                            <Box 
                                key={`${n.userId}-${idx}`}
                                p={2}
                                my={2}
                                border="1px solid #ccc"
                                borderRadius="8px"
                                sx={{
                                position: "relative",
                                width: "calc(100% - 770px)",
                                mx: "auto",
                                my: 2,
                                }}
                            >
                                <Box display="flex" alignItems="center" gap={1}>
                                <Avatar
                                    src={n.profileImageUrl || '/default-avatar.jpg'}
                                    alt={`${n.first_name || ''} ${n.last_name || ''}`}
                                    onClick={(e) => visitProfile(e, n.userId)}
                                    sx={{ width: 62, height: 62 }}
                                />
                                <Box>
                                    <Typography 
                                        variant="subtitle1" 
                                        fontWeight="bold"
                                        onClick={(e) => visitProfile(e, n.userId)}
                                        sx={{
                                            cursor: "pointer",
                                            display: "inline-block",
                                            "&:hover": {
                                                textDecoration: "underline",
                                                textDecorationColor: "currentColor", 
                                                textUnderlineOffset: "3px",
                                            },
                                        }}
                                    >
                                        {n.first_name && n.last_name
                                            ? `${n.first_name} ${n.last_name}`
                                            : 'Unknown Name'}{" "}
                                    </Typography>
                                    <Box
                                        component="span"
                                        sx={{
                                            display: "inline-block",
                                            px: 0.5,
                                            borderRadius: "4px",
                                            "&:hover": {
                                                backgroundColor: "#d9e4f0", 
                                                cursor:
                                                (n.govPostReplyContent &&
                                                        n.govPostReplyContent !== "[Reply deleted]") ||
                                                    (n.govPostCommentContent && 
                                                        n.govPostCommentContent !== "[Comment deleted]") ||
                                                    (n.govPostId && 
                                                        n.govPostContent !== "[Post deleted]") ||
                                                    (n.pollReplyText &&
                                                        n.pollReplyText !== "[Reply deleted]") ||
                                                    (n.usSenatePollReplyText &&
                                                        n.usSenatePollReplyText !== "[Reply deleted]") ||
                                                    (n.commentContent &&
                                                        n.commentContent !== "[Comment deleted]") ||
                                                    (n.replyContent &&
                                                        n.replyContent !== "[Reply deleted]") ||
                                                    (n.photoCommentText && 
                                                        n.photoCommentText !== "[Comment deleted]") ||
                                                    (n.photoReplyText && 
                                                        n.photoReplyText !== "[Reply deleted]") ||
                                                    (n.videoCommentText && 
                                                        n.videoCommentText !== "[Comment deleted]") ||
                                                    (n.videoReplyText && 
                                                        n.videoReplyText !== "[Reply deleted]") ||
                                                    (n.billReplyText && 
                                                        n.billReplyText !== "[Reply deleted]") ||
                                                    (n.scotusReplyText && 
                                                        n.scotusReplyText !== "[Reply deleted]") ||
                                                    (n.calBillReplyText && 
                                                        n.calBillReplyText !== "[Reply deleted]")
                                                        ? "pointer"
                                                        : "default",
                                            },
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (n.type == "gov post comment" && n.govPostId) {
                                                history.push(`/govPost/${n.govPostId}/comments`);
                                            } else if (n.type == "gov post reply" && n.govPostId && n.govPostReplyId) {
                                                history.push(`/govPost/${n.govPostId}/comments/${n.govPostReplyId}`);
                                            } else if (
                                                n.type === "state legislature reply" &&
                                                n.stateLegislatureId &&
                                                n.replyId
                                            ) {
                                                history.push(
                                                    `/Government/Elections/StateLegislatureElections/${n.stateLegislatureId}/comments/${n.replyId}`
                                                );
                                            } else if (
                                                n.type === "state legislature comment" &&
                                                n.stateLegislatureId &&
                                                n.commentId
                                            ) {
                                                history.push(
                                                    `/Government/Elections/StateLegislatureElections/${n.stateLegislatureId}/comments/${n.commentId}`
                                                );
                                             } else if (
                                                n.type === "statewide office reply" &&
                                                n.statewideOfficeId &&
                                                n.replyId
                                            ) {
                                                history.push(`/Government/Elections/StatewideOfficesElections/${n.statewideOfficeId}/comments/${n.replyId}`);
                                            } else if (
                                                n.type === "statewide office comment" &&
                                                n.statewideOfficeId &&
                                                n.commentId
                                            ) {
                                                history.push(`/Government/Elections/StatewideOfficesElections/${n.statewideOfficeId}/comments/${n.commentId}`);
                                            } else if (
                                                n.type === "gubernatorial elections reply" &&
                                                n.gubernatorialElectionsId &&
                                                n.replyId
                                            ) {
                                                history.push(`/Government/Elections/GubernatorialElections/${n.gubernatorialElectionsId}/comments/${n.replyId}`);
                                            } else if (
                                                n.type === "gubernatorial elections comment" &&
                                                n.gubernatorialElectionsId &&
                                                n.commentId
                                            ) {
                                                history.push(`/Government/Elections/GubernatorialElections/${n.gubernatorialElectionsId}/comments/${n.commentId}`);
                                            } else if (
                                                n.type === "us senate reply" &&
                                                n.usSenateId &&
                                                n.usSenatePollReplyTextId
                                            ) {
                                                history.push(`/Government/Elections/USSenateElections/${n.usSenateId}/comments/${n.usSenatePollReplyTextId}`);
                                            } else if (
                                                n.type === "us senate comment" &&
                                                n.usSenateId &&
                                                n.commentId
                                            ) {
                                                history.push(`/Government/Elections/USSenateElections/${n.usSenateId}/comments/${n.commentId}`);
                                            } else if (
                                                n.type === "usHouseOfRep reply" &&
                                                n.pollId &&
                                                n.pollReplyTextId
                                            ) {
                                                history.push(`/Government/Elections/USHouseOfRepElections/${n.pollId}/comments/${n.pollReplyTextId}`);
                                            } else if (
                                                n.type === "usHouseOfRep comment" &&
                                                n.pollId &&
                                                n.commentId
                                            ) {
                                                history.push(`/Government/Elections/USHouseOfRepElections/${n.pollId}/comments/${n.commentId}`);
                                            } else if (n.billId && n.billReplyText !== "[Reply deleted]") {
                                                history.push(`/bill/${n.billId}/comments/${n.billReplyTextId}`);
                                            } else if (n.calBillId && n.calBillReplyText !== "[Reply deleted]") {
                                                history.push(`/calBill/${n.calBillId}/comments/${n.calBillReplyTextId}`);
                                            } else if (n.scotusId && n.scotusReplyText !== "[Reply deleted]") {
                                                history.push(`/scotusCase/${n.scotusId}/comments/${n.scotusReplyTextId}`);
                                            } else if (n.photoReplyTextId && n.photoReplyText !== "[Reply deleted]") {
                                                history.push(`/photo/${n.photoId}/comments/${n.photoReplyTextId}`);
                                            } else if (n.photoCommentTextId && n.photoCommentText !== "[Comment deleted]") {
                                                history.push(`/photo/${n.photoId}/comments/${n.photoCommentTextId}`);
                                            } else if (n.videoReplyTextId && n.videoReplyText !== "[Reply deleted]") {
                                                history.push(`/video/${n.videoId}/comments/${n.videoReplyTextId}`);
                                            } else if (n.videoCommentTextId && n.videoCommentText !== "[Comment deleted]") {
                                                history.push(`/video/${n.videoId}/comments/${n.videoCommentTextId}`);
                                            } else if (n.replyId && n.replyContent !== "[Reply deleted]") {
                                                history.push(`/mainSocial/${n.postId}/comments/${n.replyId}`);
                                            } else if (n.commentId && n.commentContent !== "[Comment deleted]") {
                                                history.push(`/mainSocial/${n.postId}/comments/${n.commentId}`);
                                            } 
                                        }}
                                    >
                                        <Typography component="span" variant="body1" color="black">
                                            {n.type === "gov post reply"
                                                ? "replied to your comment:"
                                                : n.type === "gov post comment"
                                                ? "commented on your post:"
                                                : n.type === "usHouseOfRep reply"
                                                ? "replied to your comment:"
                                                : n.type === "usHouseOfRep comment"
                                                ? "commented on your post:"
                                                : n.type === "us senate reply"
                                                ? "replied to your comment:"
                                                : n.type === "us senate comment"
                                                ? "commented on your post:"
                                                : n.type === "gubernatorial elections reply"
                                                ? "replied to your comment:"
                                                : n.type === "gubernatorial elections comment"
                                                ? "commented on your post:"
                                                : n.type === "statewide office reply"
                                                ? "replied to your comment:"
                                                : n.type === "statewide office comment"
                                                ? "commented on your post:"
                                                : n.type === "state legislature reply"
                                                ? "replied to your comment:"
                                                : n.type === "state legislature comment"
                                                ? "commented on your post:"
                                                : n.type === "reply"
                                                ? "replied to your comment:"
                                                : n.type === "photo reply"
                                                ? "replied to your photo comment:"
                                                : n.type === "photo comment"
                                                ? "commented on your photo:"
                                                : n.type === "photo reply"
                                                ? "replied to your photo comment:"
                                                : n.type === "video comment"
                                                ? "commented on your video:"
                                                : n.type === "video reply"
                                                ? "commented on your video comment:"
                                                : n.type === "bill reply"
                                                ? "replied to your bill comment:"
                                                : n.type === "scotus reply"
                                                ? "replied to your SCOTUS case comment:"
                                                : n.type === "cal bill reply"
                                                ? "replied to your State Bill comment:"
                                                : "commented on your post:"}
                                        </Typography>

                                        <Typography
                                            component="span"
                                            variant="body1"
                                            color="text.secondary"
                                            sx={{
                                                ml: 0.5,
                                                textDecoration: "none",
                                                "&:hover": { textDecoration: "none" },
                                            }}
                                        >
                                            {" "}
                                            "
                                            {n.type === "gov post reply"
                                                ? n.govPostReplyContent || "[Reply deleted]"
                                                : n.type === "gov post comment"
                                                ? n.govPostCommentContent || "[Comment deleted]"
                                                : n.type === "usHouseOfRep reply"
                                                ? n.pollReplyText || "[Reply deleted]"
                                                : n.type === "usHouseOfRep comment"
                                                ? n.commentContent || "[Comment deleted]"
                                                : n.type === "us senate reply"
                                                ? n.usSenatePollReplyText || "[Reply deleted]"
                                                : n.type === "us senate comment"
                                                ? n.commentContent || "[Comment deleted]"
                                                : n.type === "gubernatorial elections reply"
                                                ? n.replyContent || "[Reply deleted]"
                                                : n.type === "gubernatorial elections comment"
                                                ? n.commentContent || "[Comment deleted]"
                                                : n.type === "statewide office reply"
                                                ? n.replyContent || "[Reply deleted]"
                                                : n.type === "statewide office comment"
                                                ? n.commentContent || "[Comment deleted]"
                                                : n.type === "state legislature reply"
                                                ? n.replyContent || "[Reply deleted]"
                                                : n.type === "state legislature comment"
                                                ? n.commentContent || "[Comment deleted]"
                                                : n.type === "reply"
                                                ? n.replyContent || "[Reply deleted]"
                                                : n.type === "photo reply"
                                                ? n.photoReplyText || "[Reply deleted]"
                                                : n.type === "photo comment" 
                                                ? n.photoCommentText || "[Comment deleted]"
                                                : n.type === "video comment" 
                                                ? n.videoCommentText || "[Comment deleted]"
                                                : n.type === "video reply"
                                                ? n.videoReplyText || "[Reply deleted]"
                                                : n.type === "bill reply"
                                                ? n.billReplyText || "[Reply deleted]"
                                                : n.type === "scotus reply"
                                                ? n.scotusReplyText || "[Reply deleted]"
                                                : n.type === "cal bill reply"
                                                ? n.calBillReplyText || "[Reply deleted]"
                                                : n.commentContent || "[Comment deleted]"}
                                            "
                                        </Typography>
                                    </Box>
                                    
                                    <Typography 
                                        variant="body2" 
                                        color="text.secondary"
                                        onClick={(e) => visitProfile(e, n.userId)}
                                        sx={{
                                            cursor: "pointer",
                                            display: "block",
                                            "&:hover": {
                                                textDecoration: "underline",
                                                textDecorationColor: "currentColor",
                                                textUnderlineOffset: "3px",
                                            },
                                        }}
                                    >
                                        @{n.username || 'unknown'}
                                    </Typography>
                                    <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ display: "block", mt: 0.5 }}
                                    >
                                    {new Date(n.created_at).toLocaleString()}
                                    </Typography>
                                </Box>
                                </Box>
                            </Box>
                            ))}*/}
                            {activeSection === "Comments" && (
                                <Box sx={{ width: "100%", mt: 2 }}>
                                {commentNotifications.length > 0 ? (
                                    <>
                                    {commentNotifications.map((n, idx) => {

                                        {/* ✏️ CHANGED: compute canNavigate with isNavigable() — requires non-null ID
                                            AND non-placeholder content. Old code only checked content strings,
                                            allowing navigation through null IDs. */}
                                        const canNavigate =
                                        isNavigable(n.govPostReplyId,         n.govPostReplyContent,    "[Reply deleted]")    ||
                                        isNavigable(n.govPostCommentId,        n.govPostCommentContent,  "[Comment deleted]")  ||
                                        isNavigable(n.govPostId,               n.govPostContent,         "[Post deleted]")     ||
                                        isNavigable(n.pollReplyTextId,         n.pollReplyText,          "[Reply deleted]")    ||
                                        isNavigable(n.usSenatePollReplyTextId, n.usSenatePollReplyText,  "[Reply deleted]")    ||
                                        isNavigable(n.commentId,               n.commentContent,         "[Comment deleted]")  ||
                                        isNavigable(n.replyId,                 n.replyContent,           "[Reply deleted]")    ||
                                        isNavigable(n.photoCommentTextId,      n.photoCommentText,       "[Comment deleted]")  ||
                                        isNavigable(n.photoReplyTextId,        n.photoReplyText,         "[Reply deleted]")    ||
                                        isNavigable(n.videoCommentTextId,      n.videoCommentText,       "[Comment deleted]")  ||
                                        isNavigable(n.videoReplyTextId,        n.videoReplyText,         "[Reply deleted]")    ||
                                        isNavigable(n.billReplyTextId,         n.billReplyText,          "[Reply deleted]")    ||
                                        isNavigable(n.scotusReplyTextId,       n.scotusReplyText,        "[Reply deleted]")    ||
                                        isNavigable(n.calBillReplyTextId,      n.calBillReplyText,       "[Reply deleted]");

                                        {/* ✏️ CHANGED: extracted click logic into named handler.
                                            Added `if (!canNavigate) return;` as first line — hard stop that
                                            prevents any history.push when the referenced content is deleted.
                                            All branch conditions now use isNavigable() instead of raw string checks. */}
                                        const handleCommentClick = (e) => {
                                        e.stopPropagation();
                                        if (!canNavigate) return;

                                        if (n.type === "gov post comment" && n.govPostId &&
                                            isNavigable(n.govPostCommentId, n.govPostCommentContent, "[Comment deleted]")) {
                                            history.push(`/govPost/${n.govPostId}/comments`);
                                        } else if (n.type === "gov post reply" && n.govPostId &&
                                            isNavigable(n.govPostReplyId, n.govPostReplyContent, "[Reply deleted]")) {
                                            history.push(`/govPost/${n.govPostId}/comments/${n.govPostReplyId}`);
                                        } else if (n.type === "state legislature reply" && n.stateLegislatureId &&
                                            isNavigable(n.replyId, n.replyContent, "[Reply deleted]")) {
                                            history.push(`/Government/Elections/StateLegislatureElections/${n.stateLegislatureId}/comments/${n.replyId}`);
                                        } else if (n.type === "state legislature comment" && n.stateLegislatureId &&
                                            isNavigable(n.commentId, n.commentContent, "[Comment deleted]")) {
                                            history.push(`/Government/Elections/StateLegislatureElections/${n.stateLegislatureId}/comments/${n.commentId}`);
                                        } else if (n.type === "statewide office reply" && n.statewideOfficeId &&
                                            isNavigable(n.replyId, n.replyContent, "[Reply deleted]")) {
                                            history.push(`/Government/Elections/StatewideOfficesElections/${n.statewideOfficeId}/comments/${n.replyId}`);
                                        } else if (n.type === "statewide office comment" && n.statewideOfficeId &&
                                            isNavigable(n.commentId, n.commentContent, "[Comment deleted]")) {
                                            history.push(`/Government/Elections/StatewideOfficesElections/${n.statewideOfficeId}/comments/${n.commentId}`);
                                        } else if (n.type === "gubernatorial elections reply" && n.gubernatorialElectionsId &&
                                            isNavigable(n.replyId, n.replyContent, "[Reply deleted]")) {
                                            history.push(`/Government/Elections/GubernatorialElections/${n.gubernatorialElectionsId}/comments/${n.replyId}`);
                                        } else if (n.type === "gubernatorial elections comment" && n.gubernatorialElectionsId &&
                                            isNavigable(n.commentId, n.commentContent, "[Comment deleted]")) {
                                            history.push(`/Government/Elections/GubernatorialElections/${n.gubernatorialElectionsId}/comments/${n.commentId}`);
                                        } else if (n.type === "us senate reply" && n.usSenateId &&
                                            isNavigable(n.usSenatePollReplyTextId, n.usSenatePollReplyText, "[Reply deleted]")) {
                                            history.push(`/Government/Elections/USSenateElections/${n.usSenateId}/comments/${n.usSenatePollReplyTextId}`);
                                        } else if (n.type === "us senate comment" && n.usSenateId &&
                                            isNavigable(n.commentId, n.commentContent, "[Comment deleted]")) {
                                            history.push(`/Government/Elections/USSenateElections/${n.usSenateId}/comments/${n.commentId}`);
                                        } else if (n.type === "usHouseOfRep reply" && n.pollId &&
                                            isNavigable(n.pollReplyTextId, n.pollReplyText, "[Reply deleted]")) {
                                            history.push(`/Government/Elections/USHouseOfRepElections/${n.pollId}/comments/${n.pollReplyTextId}`);
                                        } else if (n.type === "usHouseOfRep comment" && n.pollId &&
                                            isNavigable(n.commentId, n.commentContent, "[Comment deleted]")) {
                                            history.push(`/Government/Elections/USHouseOfRepElections/${n.pollId}/comments/${n.commentId}`);
                                        } else if (n.billId && isNavigable(n.billReplyTextId, n.billReplyText, "[Reply deleted]")) {
                                            history.push(`/bill/${n.billId}/comments/${n.billReplyTextId}`);
                                        } else if (n.calBillId && isNavigable(n.calBillReplyTextId, n.calBillReplyText, "[Reply deleted]")) {
                                            history.push(`/calBill/${n.calBillId}/comments/${n.calBillReplyTextId}`);
                                        } else if (n.scotusId && isNavigable(n.scotusReplyTextId, n.scotusReplyText, "[Reply deleted]")) {
                                            history.push(`/scotusCase/${n.scotusId}/comments/${n.scotusReplyTextId}`);
                                        } else if (n.photoId && isNavigable(n.photoReplyTextId, n.photoReplyText, "[Reply deleted]")) {
                                            history.push(`/photo/${n.photoId}/comments/${n.photoReplyTextId}`);
                                        } else if (n.photoId && isNavigable(n.photoCommentTextId, n.photoCommentText, "[Comment deleted]")) {
                                            history.push(`/photo/${n.photoId}/comments/${n.photoCommentTextId}`);
                                        } else if (n.videoId && isNavigable(n.videoReplyTextId, n.videoReplyText, "[Reply deleted]")) {
                                            history.push(`/video/${n.videoId}/comments/${n.videoReplyTextId}`);
                                        } else if (n.videoId && isNavigable(n.videoCommentTextId, n.videoCommentText, "[Comment deleted]")) {
                                            history.push(`/video/${n.videoId}/comments/${n.videoCommentTextId}`);
                                        } else if (n.postId && isNavigable(n.replyId, n.replyContent, "[Reply deleted]")) {
                                            history.push(`/mainSocial/${n.postId}/comments/${n.replyId}`);
                                        } else if (n.postId && isNavigable(n.commentId, n.commentContent, "[Comment deleted]")) {
                                            history.push(`/mainSocial/${n.postId}/comments/${n.commentId}`);
                                        }
                                        };

                                        return (
                                        <Box
                                            key={`${n.userId}-${idx}`}
                                            p={2} my={2} border="1px solid #ccc" borderRadius="8px"
                                            sx={{ position: "relative", width: "calc(100% - 770px)", mx: "auto", my: 2 }}
                                        >
                                            <Box display="flex" alignItems="center" gap={1}>
                                            <Avatar src={n.profileImageUrl || '/default-avatar.jpg'} alt={`${n.first_name || ''} ${n.last_name || ''}`}
                                                onClick={(e) => visitProfile(e, n.userId)} sx={{ width: 62, height: 62 }} />
                                            <Box>
                                                <Typography variant="subtitle1" fontWeight="bold" onClick={(e) => visitProfile(e, n.userId)}
                                                sx={{ cursor: "pointer", display: "inline-block", "&:hover": { textDecoration: "underline", textDecorationColor: "currentColor", textUnderlineOffset: "3px" } }}>
                                                {n.first_name && n.last_name ? `${n.first_name} ${n.last_name}` : 'Unknown Name'}{" "}
                                                </Typography>

                                                {/* ✏️ CHANGED: onClick now calls handleCommentClick (which hard-stops when
                                                    !canNavigate). cursor and hover background are driven by canNavigate
                                                    instead of the old inline multi-condition string checks. */}
                                                <Box
                                                component="span"
                                                onClick={handleCommentClick}
                                                sx={{
                                                    display: "inline-block",
                                                    px: 0.5,
                                                    borderRadius: "4px",
                                                    cursor: canNavigate ? "pointer" : "default",
                                                    "&:hover": {
                                                    backgroundColor: canNavigate ? "#d9e4f0" : "transparent",
                                                    },
                                                }}
                                                >
                                                <Typography component="span" variant="body1" color="black">
                                                    {n.type === "gov post reply"                    ? "replied to your comment:"
                                                    : n.type === "gov post comment"               ? "commented on your post:"
                                                    : n.type === "usHouseOfRep reply"             ? "replied to your comment:"
                                                    : n.type === "usHouseOfRep comment"           ? "commented on your post:"
                                                    : n.type === "us senate reply"                ? "replied to your comment:"
                                                    : n.type === "us senate comment"              ? "commented on your post:"
                                                    : n.type === "gubernatorial elections reply"   ? "replied to your comment:"
                                                    : n.type === "gubernatorial elections comment" ? "commented on your post:"
                                                    : n.type === "statewide office reply"         ? "replied to your comment:"
                                                    : n.type === "statewide office comment"       ? "commented on your post:"
                                                    : n.type === "state legislature reply"        ? "replied to your comment:"
                                                    : n.type === "state legislature comment"      ? "commented on your post:"
                                                    : n.type === "reply"                          ? "replied to your comment:"
                                                    : n.type === "photo reply"                    ? "replied to your photo comment:"
                                                    : n.type === "photo comment"                  ? "commented on your photo:"
                                                    : n.type === "video comment"                  ? "commented on your video:"
                                                    : n.type === "video reply"                    ? "replied to your video comment:"
                                                    : n.type === "bill reply"                     ? "replied to your bill comment:"
                                                    : n.type === "scotus reply"                   ? "replied to your SCOTUS case comment:"
                                                    : n.type === "cal bill reply"                 ? "replied to your State Bill comment:"
                                                    : "commented on your post:"}
                                                </Typography>
                                                <Typography component="span" variant="body1" color="text.secondary"
                                                    sx={{ ml: 0.5, textDecoration: "none", "&:hover": { textDecoration: "none" } }}>
                                                    {" "}"
                                                    {n.type === "gov post reply"                    ? n.govPostReplyContent    || "[Reply deleted]"
                                                    : n.type === "gov post comment"               ? n.govPostCommentContent  || "[Comment deleted]"
                                                    : n.type === "usHouseOfRep reply"             ? n.pollReplyText          || "[Reply deleted]"
                                                    : n.type === "usHouseOfRep comment"           ? n.commentContent         || "[Comment deleted]"
                                                    : n.type === "us senate reply"                ? n.usSenatePollReplyText  || "[Reply deleted]"
                                                    : n.type === "us senate comment"              ? n.commentContent         || "[Comment deleted]"
                                                    : n.type === "gubernatorial elections reply"   ? n.replyContent           || "[Reply deleted]"
                                                    : n.type === "gubernatorial elections comment" ? n.commentContent         || "[Comment deleted]"
                                                    : n.type === "statewide office reply"         ? n.replyContent           || "[Reply deleted]"
                                                    : n.type === "statewide office comment"       ? n.commentContent         || "[Comment deleted]"
                                                    : n.type === "state legislature reply"        ? n.replyContent           || "[Reply deleted]"
                                                    : n.type === "state legislature comment"      ? n.commentContent         || "[Comment deleted]"
                                                    : n.type === "reply"                          ? n.replyContent            || "[Reply deleted]"
                                                    : n.type === "photo reply"                    ? n.photoReplyText          || "[Reply deleted]"
                                                    : n.type === "photo comment"                  ? n.photoCommentText        || "[Comment deleted]"
                                                    : n.type === "video comment"                  ? n.videoCommentText        || "[Comment deleted]"
                                                    : n.type === "video reply"                    ? n.videoReplyText          || "[Reply deleted]"
                                                    : n.type === "bill reply"                     ? n.billReplyText           || "[Reply deleted]"
                                                    : n.type === "scotus reply"                   ? n.scotusReplyText         || "[Reply deleted]"
                                                    : n.type === "cal bill reply"                 ? n.calBillReplyText        || "[Reply deleted]"
                                                    : n.commentContent || "[Comment deleted]"}
                                                    "
                                                </Typography>
                                                </Box>

                                                <Typography variant="body2" color="text.secondary" onClick={(e) => visitProfile(e, n.userId)}
                                                sx={{ cursor: "pointer", display: "block", "&:hover": { textDecoration: "underline", textDecorationColor: "currentColor", textUnderlineOffset: "3px" } }}>
                                                @{n.username || 'unknown'}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                                {new Date(n.created_at).toLocaleString()}
                                                </Typography>
                                            </Box>
                                            </Box>
                                        </Box>
                                        );
                                    })}
                            {commentHasMore && (
                                <Box display="flex" justifyContent="center" mt={2} mb={4}>
                                    <Button
                                    variant="outlined"
                                    disabled={commentLoadingMore}
                                    onClick={async () => {
                                        setCommentLoadingMore(true);
                                        await fetchCommentNotifications(commentSkip, true);
                                        setCommentLoadingMore(false);
                                    }}
                                    >
                                    {commentLoadingMore ? "Loading..." : "Load More"}
                                    </Button>
                                </Box>
                                )}
                            </>
                        ) : (
                        <Typography variant="body2" color="text.secondary">
                            No comments yet.
                        </Typography>
                        )}
                    </Box>
                    )}

            </div>

    </div>
  );
}

export default NotificationsPage;